import { f as flatten_1 } from './flatten.mjs';
import { _ as _overRest } from './_overRest.mjs';
import { _ as _setToString } from './_setToString.mjs';

var flatten = flatten_1,
    overRest = _overRest,
    setToString = _setToString;

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

var _flatRest = flatRest;

export { _flatRest as _ };
